
<template>

	<div ref="main_div" :class="main_div_class" v-on:mousemove="mouse_move" v-on:mouseup="mouse_up">

		<div v-if="! without_border && with_resize" class="resizer resizer_right" v-on:mousedown="mouse_down"/>
		<div v-if="! without_border && with_resize" class="resizer resizer_bottom" v-on:mousedown="mouse_down"/>

		<div :class="card_body_class">

			<b-row v-on:click="() => { content_visible = ! content_visible }" v-if="! without_header" class="frame_title m-0" align-v="center">

				<b-col v-if="! without_title && title_url == null" class="frame_title_first_col p-0">

					<b-button v-if="expanded" class="transparent"><base-icon :name="content_visible ? 'chevron_more' : 'chevron_less'" /></b-button>
					<h4>{{ title }}</h4>

				</b-col>
				<b-col v-else-if="! without_title" class="frame_title_first_col p-0">

					<router-link v-if="title_url_text == null" :to="title_url">{{ title }}</router-link>
					<div v-else>{{ title }}<router-link :to="title_url">{{ title_url_text }}</router-link>{{ title_url_after_text }}</div>

				</b-col>

				<slot name="title_content"/>

				<b-col :cols="title_buttons_cols" align="right">
					
					<slot v-if="show_add_button" name="add_button">

						<b-button size="sm" variant="light" class="filter-button" v-b-tooltip.hover.bottomright :title="add_button_title" v-on:click.stop="ev => $emit('add', ev)"><b-icon-plus/></b-button>

					</slot>

					<b-button v-if="show_edit_button" size="sm" variant="light" class="filter-button" v-b-tooltip.hover.bottomright :title="edit_button_title" v-on:click.stop="ev => $emit('edit', ev)"><b-icon-pencil/></b-button>

					<slot name="title_buttons"/>

					<b-button v-if="show_delete_button" size="sm" variant="light" class="filter-button" v-b-tooltip.hover.bottomright :title="delete_button_title" v-on:click.stop="ev => $emit('delete', ev)"><b-icon-trash/></b-button>
					<b-button v-if="show_delete_all_button" size="sm" variant="light" class="filter-button" v-b-tooltip.hover.bottomright :title="delete_all_button_title" v-on:click.stop="ev => $emit('delete_all', ev)"><b-icon-trash-fill/></b-button>

					<b-button v-if="show_close_button" size="sm" variant="light" class="filter-button" v-on:click.stop="() => $emit('close')"><b-icon-x/></b-button>

				</b-col>

			</b-row>

			<b-collapse v-if="expanded" :id="id" v-model="content_visible" :visible="visible">

				<slot/>

			</b-collapse>

			<slot v-else/>

		</div>

	</div>

</template>

<script>

import { uuid } from "vue-uuid"

export default
{
	props :
	{
		title : { type : String, default : () => "" },
		title_url : { type : String, default : () => null },
		title_url_text : { type : String, default : () => null },
		title_url_after_text : { type : String, default : () => null },
		without_title : { type : Boolean, default : () => false },
		expanded : { type : Boolean, default : () => false },
		visible : { type : Boolean, default : () => true },
		without_margin : { type : Boolean, default : () => false },
		without_border : { type : Boolean, default : () => false },
		without_header : { type : Boolean, default : () => false },
		with_resize : { type : Boolean, default : () => false },
		transparent : { type : Boolean, default : () => false },
		show_add_button : { type : Boolean, default : () => false },
		show_edit_button : { type : Boolean, default : () => false },
		show_delete_button : { type : Boolean, default : () => false },
		show_delete_all_button : { type : Boolean, default : () => false },
		show_close_button : { type : Boolean, default : () => false },
		title_buttons_cols : { type : Number, default : () => 2 },
		add_button_title : { type : String, default : () => null },
		edit_button_title : { type : String, default : () => null },
		delete_button_title : { type : String, default : () => null },
		delete_all_button_title : { type : String, default : () => null },
	},

	computed :
	{
		main_div_class()
		{
			var cls = ""

			if(this.with_resize)
				cls += " resizable"

			if(! this.without_border && ! this.transparent)
				cls += " border"

			return cls
		},

		card_body_class()
		{
			var cls = ""

			if(! this.without_margin)
			{
				cls += " my-4"

				if(! this.without_border && ! this.transparent)
					cls += " mx-4"
			}

			return cls
		},
	},

	watch :
	{
		visible :
		{
			immediate : true,

			handler(visible)
			{
				if(visible != null)
					this.content_visible = visible
			}
		}
	},

	data()
	{
		return {

			id : uuid.v1(),
			content_visible : false,

			x : 0,
			y : 0,
			w : 0,
			h : 0,
			is_resizing : false,
		}
	},

	methods :
	{
		mouse_down(ev)
		{
			const styles = window.getComputedStyle(this.$refs.main_div)

			this.x = ev.clientX
			this.y = ev.clientY
			this.w = parseInt(styles.width, 10)
			this.h = parseInt(styles.height, 10)

			document.addEventListener("mousemove", this.mouse_move)
			document.addEventListener("mouseup", this.mouse_up)

			this.$refs.main_div.classList.add("resizing")

			this.is_resizing = true
		},

		mouse_move(ev)
		{
			if(this.is_resizing)
			{
				const dx = ev.clientX - this.x
				const dy = ev.clientY - this.y

				this.$refs.main_div.style.width = `${this.w + dx}px`
				this.$refs.main_div.style.height = `${this.h + dy}px`
			}
		},

		mouse_up()
		{
			document.removeEventListener("mousemove", this.mouse_move)
			document.removeEventListener("mouseup", this.mouse_up)

			this.$refs.main_div.classList.remove("resizing")

			this.is_resizing = false
		}
	}
}

</script>

<style scoped>

.frame_title
{
	user-select: none;
	border-bottom: 2px solid var(--bft-blue-200);
	border-radius: 4px;
	min-height: 2.375rem;
	padding: .5rem .5rem .375rem;
}

.frame_title_first_col
{
	display: flex;
	align-items: center;
	gap: .75rem;
}

</style>
